import React from 'react';
import { Typography } from 'antd';
import Logo from '../assets/img/logo.png';

const AuthLayout = ({ title, subtitle, children, className }) => {
  return (
    <div className={`AuthLayout ${className}`}>
      <div className="AuthLayout__Container">
        <div className="AuthLayout__Logo">
          <img src={Logo} alt="Logo" className="AuthLayout__LogoImage" />
        </div>
        <Typography.Paragraph className="AuthLayout__Subtitle">{subtitle}</Typography.Paragraph>
        <div className="AuthLayout__Content">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
